<template>
<div>
  <b-button size="lg" variant="primary" @click="onCreateNew">
    <i class="fa fa-plus mr-2"></i>
    Add new list
  </b-button>

  <b-card-group columns class="mt-3">
    <list-summary
      v-for="list in $store.state.lists.db"
      v-bind="list"
      :key="list.id"
      @view="onView(list.id)"
      @edit="initEditSession(list.id)"
      @delete="onDelete(list.id)" />
  </b-card-group>

  <div v-if="editingSessionID">
    <list-editor
      :key="editingSessionID"
      :id="editingListID"
      @close="editingSessionID = null"/>
  </div>

</div>
</template>

<script>
import ListEditor from './Editor';
import ListSummary from './Summary';
import {deleteList} from '../../store/lists';

export default {
  name: 'ListDashboard',
  components: { ListEditor, ListSummary },

  data() {
    return {
      editingListID: null,
      editingSessionID: null
    };
  },

  methods: {
    initEditSession(id) {
      this.editingListID = id;
      this.editingSessionID = (new Date()).getMilliseconds();
    },

    onCreateNew() {
      this.initEditSession();
    },

    onDelete(id) {
      this.$store.dispatch(deleteList(id)).then(console.log);
    },

    onView(id) {
      this.$router.push(`/lists/${id}`);
    }
  }
};
</script>
